import {
    faClipboard,
    faUserTie,
    faIdCard,
    faAddressCard,
    faBuilding,
    faSchool,
    faStar,
    faChartLine,
    faGraduationCap,
    faFolder,
    faFileAlt,
    faDesktop,
    faMoneyBill,
    faChartBar,
    faCircleExclamation,
    faBookOpen,
    faUserGear,
    faPeopleGroup,
    faDatabase,
    faClock,
    faUserGraduate,
    faGear,
    faUserCheck,
    faShieldAlt,
    faExclamationTriangle,
    faUserSecret,
    faWarehouse,
    faSheetPlastic,
    faUser,
    faChildren,
    faChalkboardTeacher
} from "@fortawesome/free-solid-svg-icons";
import ebda from '../assets/EBDA.jpeg';
import wabys from '../assets/wabys.png';
import GOL from '../assets/Gov.png';
import wahby from '../assets/wahby_group.png';
import wabysWatomsLogo from '../assets/wabysWatomsLogo.png';
import wabysAdminIcon from '../assets/adminIcon.png';
import wabysWisdomLogo from '../assets/wabysWisdomLogo.png';
import wabysWiseumLogo from '../assets/wabysWiseumLogo.png';
import wabysWisnmsLogo from '../assets/wabysWisnmsLogo.png';
import wabysWisecmLogo from '../assets/wabysWisecmLogo.png';
import wabysWishmsLogo from '../assets/wabysWishmsLogo.png';
import wabysWisfmsLogo from '../assets/wabysWisfmsLogo.png';
import wabysWiscmcmLogo from '../assets/wabysWiscmcmLogo.png';
import tech from '../assets/tech.jpg';
import hemam from '../assets/hemam.jpg';
import ismailiaManager from '../assets/ismailiaManager.jpg';
import ismailiaImg from '../assets/ismailiaImg.jpg';
import suezManager from '../assets/suezManager.jpg';
import sharabyaManager from '../assets/sharabyaManager.jpg';
import sharabyaImg from '../assets/sharabyaImg.jpg';
import sharqiaManager from '../assets/sharqiaManager.jpg';
import sharqiaImg from '../assets/sharqiaImg.jpg';
import boulaqManager from '../assets/boulaqManager.jpg';
import boulaqImg from '../assets/boulaqImg.jpg';

export const IMPORTANCE_LEVELS = ["normal", "important", "urgent"];

export const TASK_SIZES = ["small", "medium", "large"];

export const WISDOM_INTERVIEW_EN_TITLES = [
    "Planning for Teaching/Learning Process",
    "Integrating Technology into Teaching",
    "Utilized Teaching Methods",
    "Selecting and Utilizing Teaching/Learning Resources",
    "Classroom Management & Student Motivation",
    "Assessment Techniques & Feedback",
];

export const WISDOM_INTERVIEW_AR_TITLES = [
    "التخطيط لعملية التعليم/التعلم",
    "دمج التكنولوجيا في التعليم",
    "أساليب التدريس المستخدمة",
    "اختيار واستخدام مصادر التعليم",
    "إدارة الصف وتحفيز الطلاب",
    "تقنيات التقييم والتغذية الراجعة",
];

export const STATUS_OPTIONS = [
    // "0",
    "25",
    "50",
    "75",
    "finished",
    "on hold",
    "in progress",
    "past the due date",
    "submitted",
    "under review",
    "not started yet",
];

export const WISDOM_PMS_EN_LIST = {
    T: "Teacher",
    AC: "Academic Principle",
    C: "Curriculum",
    H: "HOD",
    EDU: "Edu Environment",
    EX: "Executive Manager",
    SPEC: "Specialist",
    W: "Work Enivornment",
    DO: "Daily Operations",
    CRO: "PD",
    WCP: "مشاركة مجتمعية",
    FT: "التدريب الميداني"
};

export const WISDOM_PMS_AR_LIST = {
    T: "المدرس",
    AC: "المدير الاكاديمي",
    C: "المناهج",
    H: "رئيس القسم",
    EDU: "البيئة التعليمية",
    EX: "المدير التنفيذي",
    SPEC: "المتخصص",
    W: "بيئة العمل",
    DO: "الأشراف المدرسي",
    CRO: "التنمية المهنية",
    WCP: "مشاركة مجتمعية",
    FT: "التدريب الميداني"
};

export const WISDOM_PMS_ROLE_PERMISSION = {
    T: "Teacher",
    HOD: "Head of Department (HOD)",
    AC: "Academic Principle",
    EX: "Executive Manager",
    S: "Student",
    Self: "Self",
    Cl: "Teacher",
    QA: "Quality Officer",
    ML: "Line Supervisor",
    E: "Employee",
    OB: "Employee",
    AD: "ADMIN",
    OEL: "Operations Excellence Lead"
};

export const WSIDOM_PMS_FORMS_ORDER = [0, 2, 4, 6, 5, 1, 3, 7, 8];

export const WISDOM_LATNESS_OPTIONS = ["5", "10", "15", "20", "25", "30"];

export const WISDOM_TEST_EN_TITLES = [
    "Planning for Teaching/Learning Process",
    "Integrating Technology into Teaching",
    "Utilized Teaching Methods",
    "Selecting and Utilizing Teaching/Learning Resources",
    "Classroom Management & Student Motivation",
    "Assessment Techniques & Feedback",
];

export const WISDOM_TEST_AR_TITLES = [
    "التخطيط لعملية التعليم/التعلم",
    "دمج التكنولوجيا في التعليم",
    "أساليب التدريس المستخدمة",
    "اختيار واستخدام مصادر التعليم",
    "إدارة الصف وتحفيز الطلاب",
    "تقنيات التقييم والتغذية الراجعة",
];

export const WATOMS_INTERVIEW_TITLES = [
    "تخطيط وتصميم التدريس القائم على الجدارات",
    "إدارة الصف ومشاركة الطلاب",
    "اختيار وتصميم مصادر التعلم",
    "توظيف التكنولوجيا في التعليم",
    "أفضل استخدام لأساليب التدريس",
    "تقنيات التقييم والتقويم التربوي",
];

export const WATOMS_PMS_LIST = {
    IP: "الاداء المؤسسي",
    PO: "التخطيط و التشغيل",
    W: "بيئة العمل",
    TE: "بيئة التدريب",
    QD: "الجودة و التطوير",
    DD: "الرقمنة و تخزين البيانات",
    TP: "مسار التدريب",
    TG: "البرامج التدريبية",
    TR: "اداء المتدرب",
    T: "اداء المدرب",
    CP: "المشاركة المجتمعية",
    CRO: "التنمية المهنية",
    BF: "الأبنية و المرافق"
};

export const WATOMS_PMS_ROLE_PERMISSION = {
    Self: "Self",
    T: "Teacher",
    TS: "Teacher",
    TR: "Student",
    AD: "ADMIN",
    MGR: "Manager",
    OEL: "Operations Excellence Lead",
    SV: "VtcSupervisor",
    CRO: "ClassRoom Observation"
};

export const WATOMS_PMS_FORMS_ORDER = [4, 1, 2, 6, 8, 3, 0, 5, 9, 7];

export const WATOMS_TEST_TITLES = [
    "التخطيط لعملية التعليم/التعلم",
    "دمج التكنولوجيا في التعليم",
    "أساليب التدريس المستخدمة",
    "اختيار واستخدام مصادر التعليم",
    "إدارة الصف وتحفيز الطلاب",
    "تقنيات التقييم والتغذية الراجعة",
];

export const PARTNERS = [
    { title: "وابيز للتدريب و التعليم", image: wabys, width: "w-40" },
    { title: "وزارة العمل المصرية", image: GOL, width: "w-24" },
    { title: "ابدأ لتنمية الصناعات", image: ebda, width: "w-40" },
    { title: "وهبي جروب", image: wahby, width: "w-56" },
];

export const TEACHER_LATENESS_ENGLISH_TITLES = [
    "Class",
    "Session 1",
    "Session 2",
    "Session 3",
    "Session 4",
    "Session 5",
    "Session 6",
    "Session 7",
    "Session 8",
    "Session 9",
    "Session 10"
];

export const TEACHER_LATENESS_ARABIC_TITLES = [
    "الفصل",
    "الحصة ١",
    "الحصة ٢",
    "الحصة ٣",
    "الحصة ٤",
    "الحصة ٥",
    "الحصة ٦",
    "الحصة ٧",
    "الحصة ٨",
    "الحصة ٩",
    "الحصة ١٠"
];

export const NEQATY_PERMISSION_STATUS = [
    "accepted",
    "pending",
    "denied"
]

export const SCHOOL_CURRICULUM_RELATION = {
    1: [1, 2, 3, 13, 14, 15, 16, 17, 18, 46, 47],
    2: [1, 2, 3, 13, 14, 15, 16, 17, 18]
}

export const ORGANIZATIONS_TYPE = [
    "School",
    "Institution"
]

export const ASSESSOR_TYPE = [
    "Employee / Teacher / Trainer",
    "Student / Trainee"
]

export const getEbdaEduSystems = (language, userOrg) => [
    {
        id: 'tms',
        title: 'TMS',
        subtitle: language ? 'Task Management System' : 'نظام إدارة المهام',
        description: language ? 'Task and development management' : 'إدارة التدريب والتطوير',
        icon: faGraduationCap,
        path: '/admin/tms',
        color: 'from-purple-500 to-purple-600',
        available: false
    },
    {
        id: 'admin',
        title: 'ADMIN PANEL',
        subtitle: language ? 'Administrative controls for managing the system' : 'الضوابط الإدارية لإدارة النظام',
        description: language ? 'Administrative controls for managing the system' : 'الضوابط الإدارية لإدارة النظام',
        icon: faGear,
        path: '/admin/admin-panel',
        color: 'from-blue-900 to-blue-950',
        available: true
    }
];

export const EbdaEduAdminPanelSettings = (language, ebdaUserInfo) => [
    {
        id: 'watoms trainers registrations',
        title: 'WATOMS TRAINERS REGISTRATIONS',
        subtitle: language ? 'View Watoms Trainers Registrations' : 'تقديمات المدربين الخاص بواتمز',
        description: language ? 'View Watoms Trainers Registrations' : 'تقديمات المدربين الخاص بواتمز',
        icon: faUserTie,
        path: '/admin/admin-panel/view-trainer-registrations',
        color: 'from-purple-500 to-purple-600',
        available: true
    },
    {
        id: 'watoms trainees registrations',
        title: 'WATOMS TRAINEES REGISTRATIONS',
        subtitle: language ? 'View Watoms Trainees Registrations' : 'تقديمات المتدربين الخاص بواتمز',
        description: language ? 'View Watoms Trainees Registrations' : 'تقديمات المتدربين الخاص بواتمز',
        icon: faUserGraduate,
        path: '/admin/admin-panel/view-trainees-registrations',
        color: 'from-green-500 to-green-600',
        available: true
    },
    {
        id: 'watoms course management',
        title: 'WATOMS COURSE MANAGEMENT',
        subtitle: language ? 'manage watoms courses' : 'ادارة دورات واتمز',
        description: language ? 'manage watoms courses' : 'ادارة دورات واتمز',
        icon: faWarehouse,
        path: '/admin/admin-panel/watoms-course-management',
        color: 'from-yellow-500 to-yellow-600',
        available: true
    },
    {
        id: 'watoms trainee attendance',
        title: 'WATOMS TRAINEE ATTENDANCE',
        subtitle: language ? 'view watoms trainee attendance' : 'اظهار حضور المتدربين الخاصين بواتمزُ',
        description: language ? 'view watoms trainee attendance' : 'اظهار حضور المتدربين الخاصين بواتمزُ',
        icon: faUserGraduate,
        path: '/admin/admin-panel/view-trainee-attendance',
        color: 'from-red-500 to-red-600',
        available: true
    },
    {
        id: 'watoms evaluate managers',
        title: 'WATOMS EVALUATE MANAGERS',
        subtitle: language ? 'watoms managers evaluation form' : 'استمارة تقييم مديري مراكز واتمز',
        description: language ? 'watoms managers evaluation form' : 'استمارة تقييم مديري مراكز واتمز',
        icon: faUserSecret,
        path: '/admin/admin-panel/evaluate/managers',
        color: 'from-slate-500 to-slate-600',
        available: ebdaUserInfo?.code === 1 || ebdaUserInfo?.code === 2 || ebdaUserInfo?.code === 3 || ebdaUserInfo?.code === 100 || ebdaUserInfo?.code === 300
    },
    {
        id: 'watoms workshop report',
        title: 'WATOMS WORKSHOP REPORT',
        subtitle: language ? 'watoms training evaluation, buildings and facilities report' : 'تقرير بيئة التدريب و الابنية و المرافق بواتمز',
        description: language ? 'watoms training evaluation, buildings and facilities report' : 'تقرير بيئة التدريب و الابنية و المرافق بواتمز',
        icon: faWarehouse,
        path: '/admin/admin-panel/workshop-report',
        color: 'from-emerald-500 to-emerald-600',
        available: ebdaUserInfo?.code === 1 || ebdaUserInfo?.code === 2 || ebdaUserInfo?.code === 3 || ebdaUserInfo?.code === 100 || ebdaUserInfo?.code === 300 || ebdaUserInfo?.code === 2148
    },
    {
        id: 'checkIns',
        title: 'Ebda Edu Employees CheckIns',
        subtitle: language ? 'Ebda Edu Employees CheckIns' : 'تسجيلات الحضور لموظفين شركة ابدا اديو',
        description: language ? 'Ebda Edu Employees CheckIns' : 'تسجيلات الحضور لموظفين شركة ابدا اديو',
        icon: faUserCheck,
        path: '/admin/admin-panel/checkIns',
        color: 'from-blue-500 to-blue-600',
        available: ebdaUserInfo.code === 1 || ebdaUserInfo.code === 3 || ebdaUserInfo.code === 100
    },
    {
        id: 'watoms vtc performance report',
        title: 'Watoms Vtc Performance Report',
        subtitle: language ? 'Watoms Vtc Performance Report' : 'تقييم اداء المراكز التابعة لواتمز',
        description: language ? 'Watoms Vtc Performance Report' : 'تقييم اداء المراكز التابعة لواتمز',
        icon: faSheetPlastic,
        path: '/admin/admin-panel/watoms-vtc-performance-report',
        color: 'from-fuchsia-500 to-fuchsia-600',
        available: true
    },
    {
        id: 'create org',
        title: 'New Organization',
        subtitle: language ? 'Create New Organization' : 'انشاء منظمة جديدة',
        description: language ? 'Create New Organization' : 'انشاء منظمة جديدة',
        icon: faBuilding,
        path: '/admin/create-organization',
        color: 'from-rose-500 to-rose-600',
        available: ebdaUserInfo.code === 3
    },
    {
        id: 'bulk students',
        title: 'Bulk Students Data',
        subtitle: language ? 'Add Bulk Students Data' : 'اضافة بيانات طلاب',
        description: language ? 'Add Bulk Students Data' : 'اضافة بيانات طلاب',
        icon: faUser,
        path: '/admin/bulk-students',
        color: 'from-yellow-400 to-yellow-500',
        available: true
    },
    {
        id: 'user image upload',
        title: 'User Image Upload',
        subtitle: language ? 'Add Profile Image to Existing User' : 'اضافة صورة شخصية لمستخدم',
        description: language ? 'Add Profile Image to Existing User' : 'اضافة صورة شخصية لمستخدم',
        icon: faUser,
        path: '/admin/user-image-upload',
        color: 'from-blue-400 to-blue-500',
        available: true
    },
    {
        id: 'user role config',
        title: 'User Role Config',
        subtitle: language ? 'Manage User Roles' : 'ادارة دور المستخدم',
        description: language ? 'Manage User Roles' : 'ادارة دور المستخدم',
        icon: faGear,
        path: '/admin/user-role',
        color: 'from-yellow-200 to-yellow-600',
        available: true
    }
];

export const getWatomsSystems = (language, userOrg, userInfo) => [
    {
        id: 'pms',
        title: 'Perfo.MS',
        subtitle: language ? 'Performance Management System' : 'نظام إدارة الأداء',
        description: language ? 'Performance management and human resources' : 'إدارة الأداء والموارد البشرية',
        icon: faChartLine,
        path: '/watoms/pms',
        color: 'from-blue-500 to-blue-600',
        available: true,
        notificationStatus: false
    },
    {
        id: 'dms',
        title: 'DMS',
        subtitle: language ? 'Document Management System' : 'نظام إدارة الوثائق',
        description: language ? 'Document and file management' : 'إدارة الوثائق والملفات',
        icon: faFolder,
        path: '/watoms/dms',
        color: 'from-green-500 to-green-600',
        available: true,
        notificationStatus: false
    },
    {
        id: 'tms',
        title: 'TMS',
        subtitle: language ? 'Task Management System' : 'نظام إدارة التدريب',
        description: language ? 'Task and development management' : 'إدارة التدريب والتطوير',
        icon: faGraduationCap,
        path: '/watoms/tms',
        color: 'from-purple-500 to-purple-600',
        available: true,
        notificationStatus: true,
        notificationNumber: 3,
    },
    {
        id: 'lms',
        title: 'LMS',
        subtitle: language ? 'Learning Management System' : 'نظام إدارة التعلم',
        description: language ? 'E-learning management system' : 'نظام إدارة التعلم الإلكتروني',
        icon: faDesktop,
        path: '/lms',
        color: 'from-indigo-500 to-indigo-600',
        available: false,
        notificationStatus: false
    },
    {
        id: 'pdms',
        title: 'PDMS',
        subtitle: language ? 'Professional Development Management System' : 'نظام ادارة التنمية المهنية',
        description: language ? 'Professional Development management' : 'إدارة التنمية المهنية',
        icon: faFileAlt,
        path: '/watoms/pdms',
        color: 'from-orange-500 to-orange-600',
        available: userOrg === 13,
        notificationStatus: false
    },
    {
        id: 'IMS',
        title: language ? 'IMS' : 'IMS',
        subtitle: language ? 'Points and Rewards System' : 'نظام النقاط والمكافآت',
        description: language ? 'Points management and incentives' : 'إدارة النقاط والحوافز',
        icon: faStar,
        path: '/neqaty/vtcs',
        color: 'from-yellow-500 to-yellow-600',
        available: userOrg === 13 || (userInfo.code === 1170 || userInfo.code === 1171 || userInfo.code === 1263),
        notificationStatus: false
    },
    {
        id: 'Finance System',
        title: language ? 'Finance System' : 'Finance System',
        subtitle: language ? 'Financial Management System' : 'نظام إدارة المالية',
        description: language ? 'Financial and accounting management' : 'إدارة الشؤون المالية والمحاسبية',
        icon: faMoneyBill,
        path: '/finance',
        color: 'from-emerald-500 to-emerald-600',
        available: false,
        notificationStatus: false
    },
    {
        id: 'hr',
        title: 'HR System',
        subtitle: language ? 'Human Resources System' : 'نظام الموارد البشرية',
        description: language ? 'Employee affairs management' : 'إدارة شؤون الموظفين',
        icon: faUserTie,
        path: '/hr',
        color: 'from-pink-500 to-pink-600',
        available: false,
        notificationStatus: false
    },
    {
        id: 'INFA',
        title: language ? 'INFA.S' : 'INFA.S',
        subtitle: language ? 'Infrastructure Management System' : 'نظام ادارة البنية التحتية',
        description: language ? 'Efficient and effective management and monitoring of infrastructure.' : 'ادارة البنية التحتية بكفاءة و فاعلية',
        icon: faBuilding,
        path: '/watoms/dashboard',
        color: 'from-slate-500 to-slate-600',
        available: false,
        notificationStatus: false
    },
    {
        id: 'dashboards',
        title: language ? 'Dashboards' : 'لوحات التحكم',
        subtitle: language ? 'Control Panels and Statistics' : 'لوحات التحكم والإحصائيات',
        description: language ? 'Interactive management dashboards' : 'لوحات تحكم تفاعلية للإدارة',
        icon: faChartBar,
        path: userOrg === 14 || userOrg === 13 ? '/demo/dashboard' : '/watoms/dashboard',
        color: 'from-cyan-500 to-cyan-600',
        available: true,
        notificationStatus: false
    },
    {
        id: 'Professional examination',
        title: language ? 'Professional examination' : 'فحص مهني',
        subtitle: language ? 'Control Panels and Statistics' : 'لوحات التحكم والإحصائيات',
        description: language ? 'Interactive management dashboards' : 'لوحات تحكم تفاعلية للإدارة',
        icon: faChartBar,
        path: '/watoms/pe',
        color: 'from-red-500 to-red-600',
        available: userInfo?.code === 3 || userInfo?.code === 1 || userInfo?.code === 2 || userInfo?.code === 100 || userInfo?.user_role === "PE Observer" ? true : false,
        notificationStatus: false
    }
];

export const getWisdomSystems = (language, userOrg, userInfo) => [
    {
        id: 'pms',
        title: 'Perfo.MS',
        subtitle: language ? 'Performance Management System' : 'نظام إدارة الأداء',
        description: language ? 'Performance management and human resources' : 'إدارة الأداء والموارد البشرية',
        icon: faChartLine,
        path: '/pms',
        color: 'from-blue-500 to-blue-600',
        available: userInfo?.user_role !== 'Wisdom Observer'
    },
    {
        id: 'dms',
        title: 'DMS',
        subtitle: language ? 'Document Management System' : 'نظام إدارة الوثائق',
        description: language ? 'Document and file management' : 'إدارة الوثائق والملفات',
        icon: faFolder,
        path: '/dms',
        color: 'from-green-500 to-green-600',
        available: userInfo?.user_role !== 'Wisdom Observer'
    },
    {
        id: 'tms',
        title: 'TMS',
        subtitle: language ? 'Task Management System' : 'نظام إدارة المهام',
        description: language ? 'Task and development management' : 'إدارة المهام والتطوير',
        icon: faGraduationCap,
        path: '/tms',
        color: 'from-purple-500 to-purple-600',
        available: userInfo?.user_role !== 'Wisdom Observer'
    },
    {
        id: 'lms',
        title: 'LMS',
        subtitle: language ? 'Learning Management System' : 'نظام إدارة التعلم',
        description: language ? 'E-learning management system' : 'نظام إدارة التعلم الإلكتروني',
        icon: faDesktop,
        path: '/lms',
        color: 'from-indigo-500 to-indigo-600',
        available: false,
        notificationStatus: false
    },
    {
        id: 'pdms',
        title: 'PDMS',
        subtitle: language ? 'Professional Development Management System' : 'نظام ادارة التنمية المهنية',
        description: language ? 'Professional Development management' : 'إدارة التنمية المهنية',
        icon: faFileAlt,
        path: '/wisdom/pdms',
        color: 'from-orange-500 to-orange-600',
        available: userOrg === 13 && userInfo?.user_role !== 'Wisdom Observer'
    },
    {
        id: 'IMS',
        title: language ? 'IMS' : 'IMS',
        subtitle: language ? 'Points and Rewards System' : 'نظام النقاط والمكافآت',
        description: language ? 'Points management and incentives' : 'إدارة النقاط والحوافز',
        icon: faStar,
        path: '/neqaty/schools',
        color: 'from-yellow-500 to-yellow-600',
        available: userInfo?.user_role !== 'Wisdom Observer'
    },
    {
        id: 'Finance System',
        title: language ? 'Finance System' : 'Finance System',
        subtitle: language ? 'Financial Management System' : 'نظام إدارة المالية',
        description: language ? 'Financial and accounting management' : 'إدارة الشؤون المالية والمحاسبية',
        icon: faMoneyBill,
        path: '/finance',
        color: 'from-emerald-500 to-emerald-600',
        available: false,
        notificationStatus: false
    },
    {
        id: 'hr',
        title: 'HR System',
        subtitle: language ? 'Human Resources System' : 'نظام الموارد البشرية',
        description: language ? 'Employee affairs management' : 'إدارة شؤون الموظفين',
        icon: faUserTie,
        path: '/hr',
        color: 'from-pink-500 to-pink-600',
        available: false,
        notificationStatus: false
    },
    {
        id: 'dashboards',
        title: language ? 'Dashboards' : 'لوحات التحكم',
        subtitle: language ? 'Control Panels and Statistics' : 'لوحات التحكم والإحصائيات',
        description: language ? 'Interactive management dashboards' : 'لوحات تحكم تفاعلية للإدارة',
        icon: faChartBar,
        path: '/wisdom/dashboard',
        color: 'from-cyan-500 to-cyan-600',
        available: true
    },
    {
        id: 'Admin Panel',
        title: language ? 'Admin Panel' : 'Admin Panel',
        subtitle: language ? 'Admin Panel' : 'لوحة التحكم الإدارية',
        description: language ? 'Admin Panel' : 'لوحة التحكم الإدارية',
        icon: faGear,
        path: '/wisdom/admin',
        color: 'from-blue-500 to-blue-600',
        available: userInfo?.organization_id === 13 || userInfo?.employee_role === "Academic Principal" || userInfo?.employee_role === "Executive Manager"
    },
    {
        id: 'WAMM',
        title: language ? 'WAMM' : 'WAMM',
        subtitle: language ? 'Wisdom Institutional & Program Accreditation Maturity Model' : 'نموذج نضج الاعتماد المؤسسي والبرامجي لوابيز',
        description: language ? 'Wisdom Institutional & Program Accreditation Maturity Model' : 'نموذج نضج الاعتماد المؤسسي والبرامجي لوابيز',
        icon: faGear,
        path: '/wisdom/wamm',
        color: 'from-red-500 to-red-600',
        available: true
    },
    {
        id: 'student records',
        title: language ? 'Student Records' : 'Student Records',
        subtitle: language ? 'Student Records' : 'سجل الطلاب',
        description: language ? 'Student Records' : 'سجل الطلاب',
        icon: faChildren,
        path: '/parent',
        color: 'from-blue-500 to-blue-600',
        available: userOrg === 13 || userInfo?.user_role === "Teacher" || userInfo?.user_role === "Head of Department (HOD)" || userInfo?.user_role === "Executive Manager" || userInfo?.user_role === "Academic Principle"
    }
];

export const getWabysSystems = (language, user, userSystems) => [
    {
        id: 'watoms',
        title: 'Watoms',
        subtitle: 'WABYS',
        redSubtitle: 'Auto Training Operations ',
        subtitle2: 'Management System',
        icon: wabysWisdomLogo,
        path: '/watoms',
        color: 'from-blue-500 to-blue-600',
        available: userSystems.some(system => system.id === 2)
    },
    {
        id: 'wisdom',
        title: 'Wisdom',
        subtitle: 'WABYS Integrated Systems for ',
        redSubtitle: 'Dedactics and Operations',
        subtitle2: ' Management',
        icon: wabysWatomsLogo,
        path: '/wisdom',
        color: 'from-green-500 to-green-600',
        available: userSystems.some(system => system.id === 1)
    },
    {
        id: 'wabys',
        title: 'Wabys',
        subtitle: 'WABYS Integrated Systems for',
        redSubtitle: 'Adminstration',
        subtitle2: ' Management',
        icon: wabysAdminIcon,
        path: '/admin',
        color: 'from-purple-500 to-purple-600',
        available: userSystems.some(system => system.id === 3)
    },
    {
        id: 'wiseum',
        title: 'Wiseum',
        subtitle: 'WABYS Integrated Systems for ',
        redSubtitle: 'Effective University',
        subtitle2: ' Management',
        icon: wabysWiseumLogo,
        path: '',
        color: 'from-purple-500 to-purple-600',
        available: false
    },
    {
        id: 'wisnms',
        title: 'Wisnms',
        subtitle: 'WABYS Integrated Systems for ',
        redSubtitle: 'Nurseries',
        subtitle2: ' Management System',
        icon: wabysWisnmsLogo,
        path: '',
        color: 'from-indigo-500 to-indigo-600',
        available: false
    },
    {
        id: 'wisecm',
        title: 'Wisecm',
        subtitle: 'WABYS Integrated Systems for ',
        redSubtitle: 'Education Centers',
        subtitle2: ' Managemenet',
        icon: wabysWisecmLogo,
        path: '',
        color: 'from-orange-500 to-orange-600',
        available: false
    },
    {
        id: 'wishms',
        title: 'Wishms',
        subtitle: 'WABYS Integrated Systems for ',
        redSubtitle: 'Hospital',
        subtitle2: ' Management System',
        icon: wabysWishmsLogo,
        path: '',
        color: 'from-yellow-500 to-yellow-600',
        available: false
    },
    {
        id: 'wisfms',
        title: 'Wisfms',
        subtitle: 'WABYS Integrated Systems for ',
        redSubtitle: 'Factories',
        subtitle2: ' Management System',
        icon: wabysWisfmsLogo,
        path: '',
        color: 'from-emerald-500 to-emerald-600',
        available: false
    },
    {
        id: 'wiscmcm',
        title: 'Wiscmcm',
        subtitle: 'WABYS Integrated Systems for ',
        redSubtitle: 'Car Maintenance Centers',
        subtitle2: ' Management System',
        icon: wabysWiscmcmLogo,
        path: '',
        color: 'from-pink-500 to-pink-600',
        available: false
    },
    {
        id: 'comingSoon1',
        title: 'Coming Soon',
        subtitle: '',
        redSubtitle: '',
        subtitle2: '',
        icon: faCircleExclamation,
        path: '',
        color: 'from-cyan-500 to-cyan-600',
        available: false
    }
];

export const ORGANIZATION_OTHER_LANGUAGE = {
    "Badr": "بدر",
    "Damietta": "دمياط",
    "مركز الاسماعيلية": "ismailia",
    "مركز السويس": "suez",
    "مركز الشرابية": "sharabya",
    "مركز بولاق": "boulaq",
    "مركز الشرقية": "sharqia",
    "Ebda (Test)": "ابدا (اختبار)"
}

export const WATOMS_PROJECTS = [
    {
        code: "EIVOTS",
        english_title: "Vocational training center",
        arabic_title: "تطوير و تشغيل مراكز التدريب المهني",
        image: GOL,
        projects: [
            {
                title: "test",
                image: tech
            },
            {
                title: "test",
                image: hemam
            },
            {
                title: "test",
                image: tech
            },
        ]
    },
    {
        code: "FFGD",
        english_title: "Vocational training center",
        arabic_title: "تطوير و تشغيل مراكز التدريب المهني",
        image: GOL,
        projects: [
            {
                title: "test",
                image: tech
            },
            {
                title: "test",
                image: tech
            },
            {
                title: "test",
                image: tech
            },
        ]
    },
    {
        code: "KAJG",
        english_title: "Vocational training center",
        arabic_title: "تطوير و تشغيل مراكز التدريب المهني",
        image: GOL,
        projects: [
            {
                title: "test",
                image: tech
            },
            {
                title: "test",
                image: tech
            },
            {
                title: "test",
                image: tech
            },
        ]
    },
    {
        code: "DESFG",
        english_title: "Vocational training center",
        arabic_title: "تطوير و تشغيل مراكز التدريب المهني",
        image: GOL,
        projects: [
            {
                title: "test",
                image: tech
            },
            {
                title: "test",
                image: tech
            },
            {
                title: "test",
                image: tech
            },
        ]
    },
    {
        code: "SDGAS",
        english_title: "Vocational training center",
        arabic_title: "تطوير و تشغيل مراكز التدريب المهني",
        image: GOL,
        projects: [
            {
                title: "test",
                image: tech
            },
            {
                title: "test",
                image: tech
            },
            {
                title: "test",
                image: tech
            },
        ]
    },
    {
        code: "SDFS",
        english_title: "Vocational training center",
        arabic_title: "تطوير و تشغيل مراكز التدريب المهني",
        image: GOL,
        projects: [
            {
                title: "test",
                image: tech
            },
            {
                title: "test",
                image: tech
            },
            {
                title: "test",
                image: tech
            },
        ]
    }
]

export const TRAINEES_CERTIFICATES = [
    "حاصل علي شهادة الاعدادية",
    "حاصل علي شهادة الثانوية",
    "طالب جامعي",
    "حاصل علي شهادة دبلوم",
    "حاصل علي شهادة جامعية"
]

export const KNOWN_US = [
    "فيسبوك",
    "انستاجرام",
    "تيك توك",
    "لينكدان",
    "صفحات وزارة العمل",
    "صفحة وزارة التربية و التعليم",
    "صديق",
    "Others",
]

export const ORG_MANAGER_IMG = [
    {
        id: 4,
        img: ismailiaManager,
        org: ismailiaImg
    },
    {
        id: 5,
        img: suezManager,
        org: ""
    },
    {
        id: 7,
        img: sharabyaManager,
        org: sharabyaImg
    },
    {
        id: 8,
        img: boulaqManager,
        org: boulaqImg
    },
    {
        id: 9,
        img: sharqiaManager,
        org: sharqiaImg
    },
]

export const INSTITUTION_NO_CURRICULUMS = {
    4: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],
    5: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    7: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    8: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
    9: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
}

export const DEMO_NO_CURRICULUMS = {
    14: [1]
}

export const WATOMS_UNPREPARED_DATA = {
    "All": {
        workShops: 59,
        labs: 6,
        employees: 39,
        trainers: 18,
        supervisors: 10,
        admins: 6,
    },
    4: {
        workShops: 18,
        labs: 2,
        employees: 12,
        trainers: 3,
        supervisors: 7,
        admins: 1,
    },
    5: {
        workShops: 7,
        labs: 1,
        employees: 5,
        trainers: 1,
        supervisors: 2,
        admins: 1,
    },
    7: {
        workShops: 9,
        labs: 1,
        employees: 8,
        trainers: 2,
        supervisors: 1,
        admins: 4,
    },
    8: {
        workShops: 17,
        labs: 1,
        employees: 8,
        trainers: 7,
        supervisors: 0,
        admins: 0,
    },
    9: {
        workShops: 8,
        labs: 1,
        employees: 6,
        trainers: 5,
        supervisors: 0,
        admins: 0,
    },
}

export const WATOMS_MODERN_COLORS = [
    'linear-gradient(90deg, #3fd8ff 0%, #0072ff 100%)',
    'linear-gradient(90deg, #ffb6ec 0%, #ff3c8e 100%)',
    'linear-gradient(90deg, #ffb347 0%, #ff7c00 100%)',
    'linear-gradient(90deg, #bdbdbd 0%, #757575 100%)',
];

export const WATOMS_MODERN_COLORS_TW = [
    'bg-gradient-to-r from-[#3fd8ff] to-[#0072ff]',
    'bg-gradient-to-r from-[#ffb6ec] to-[#ff3c8e]',
    'bg-gradient-to-r from-[#ffb347] to-[#ff7c00]',
    'bg-gradient-to-r from-[#bdbdbd] to-[#757575]',
    'bg-gradient-to-r from-blue-400 to-blue-600',
    'bg-gradient-to-r from-red-400 to-red-600',
];


export const NUMBER_TO_ARABIC_MONTHS = {
    1: 'يناير',
    2: 'فبراير',
    3: 'مارس',
    4: 'ابريل',
    5: 'مايو',
    6: 'يونيو',
    7: 'يوليو',
    8: 'اغسطس',
    9: 'سبتمبر',
    10: 'اكتوبر',
    11: 'نوفمبر',
    12: 'ديسمبر'
}

export const MONTHS_ARABIC = [
    { monthNumber: 1, month: "يناير" },
    { monthNumber: 2, month: "فبراير" },
    { monthNumber: 3, month: "مارس" },
    { monthNumber: 4, month: "أبريل" },
    { monthNumber: 5, month: "مايو" },
    { monthNumber: 6, month: "يونيو" },
    { monthNumber: 7, month: "يوليو" },
    { monthNumber: 8, month: "أغسطس" },
    { monthNumber: 9, month: "سبتمبر" },
    { monthNumber: 10, month: "أكتوبر" },
    { monthNumber: 11, month: "نوفمبر" },
    { monthNumber: 12, month: "ديسمبر" },
];

export const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const COUNTRYS = [
    "المملكة العربية السعودية",
    "الامارات العربية المتحدة",
    "قطر",
    "البحرين"
]

export const ORGANIZATION_CITY_RELATION = {
    4: "الاسماعيلية",
    5: "السويس",
    7: "القاهرة",
    8: "الجيزة",
    9: "الشرقية",
    16: "الوادي الجديد",
    17: "دمياط",
    18: "الشرقية",
    19: "بني سويف",
    20: "الاقصر",
    21: "شمال سيناء",
    22: "شمال سيناء",
    23: "شمال سيناء",
    24: "جنوب سيناء",
    25: "البحيرة",
    26: "بورسعيد",
    27: "القليوبية",
    28: "القليوبية",
    29: "قنا",
    30: "اسيوط",
    31: "كفر الشيخ",
    32: "الغربية",
    33: "مطروح",
    34: "سوهاج",
    35: "سوهاج",
    36: "سوهاج",
    37: "الدقهلية",
    38: "الدقهلية",
    39: "الدقهلية",
    40: "الدقهلية",
    41: "المنيا",
    42: "اسوان",
    43: "المنوفية",
    44: "الاسكندرية",
    45: "الاسكندرية",
    46: "الاسكندرية",
    47: "الاسكندرية",
    48: "ك7 حي الشروق"
}

export const VTCS_BEOFRE_AND_AFTER = {
    4: "https://www.canva.com/design/DAG0wdqREeA/TaXZJLTo19gCfXZnkHLSVg/edit",
    5: "https://www.canva.com/design/DAG0wdIUOus/PsscQYlic0BSceDuaVl2VQ/edit",
    7: "https://www.canva.com/design/DAG0wZHblws/86TW0VlmG_rz7EHDYV9y1A/edit",
    8: "https://www.canva.com/design/DAG0wSdTZUI/3jSPfd338nMFahLn5mHZgw/edit",
    9: "https://www.canva.com/design/DAG0wfo_GYk/xqGwNSW6rY2HiBM61QeHrw/edit"
}

export const PMS_CATEGORY_CARD_ICON = (categoryCode) => {
    const iconMap = {
        "اداء المدرب": faUserTie,
        "الاداء المؤسسي": faGraduationCap,
        "البرامج التدريبية": faBookOpen,
        "التخطيط و التشغيل": faUserGear,
        "بيئة التدريب": faSchool,
        "المشاركة المجتمعية": faPeopleGroup,
        "الرقمنة و تخزين البيانات": faDatabase,
        "بيئة العمل": faAddressCard,
        "الاشراف اليومي": faClock,
        "التنمية المهنية": faChartLine,
        "اداء المتدرب": faUserGraduate,
        "الجودة و التطوير": faStar,
        "تقرير الاداء": faStar,
    };
    return iconMap[categoryCode] || faClipboard;
};

export const PMS_CATEGORY_CARD_COLOR = (code) => {
    const map = {
        "اداء المدرب": "from-blue-400 to-blue-600",
        "الاداء المؤسسي": "from-purple-400 to-purple-600",
        "بيئة التدريب": "from-yellow-300 to-yellow-500",
        "اداء المتدرب": "from-indigo-400 to-indigo-600",
        "التخطيط و التشغيل": "from-red-400 to-red-600",
        "البرامج التدريبية": "from-green-400 to-green-600",
        "بيئة العمل": "from-gray-400 to-gray-600",
        "التنمية المهنية": "from-pink-400 to-pink-600",
        "الاشراف اليومي": "from-teal-400 to-teal-600",
        "الرقمنة و تخزين البيانات": "from-orange-400 to-orange-600",
        "الجودة و التطوير": "from-yellow-400 to-yellow-600",
        "المشاركة المجتمعية": "from-green-600 to-green-800",
        "تقرير الاداء": "from-green-600 to-green-800"
    };
    return map[code] || "from-slate-300 to-slate-500";
};

export const IMPORTANCE_ARABIC_VERSION = {
    normal: "عادية",
    important: "متوسطة",
    urgent: "قصوي"
}

export const SIZE_ARABIC_VERSION = {
    small: "صغيرة",
    medium: "متوسطة",
    large: "كبيرة"
}

export const WATOMS_VTCS_CITIES = [
    "الاسكندرية",
    "الاسماعيلية",
    "اسوان",
    "اسيوط",
    "الأقصر",
    "البحر الأحمر",
    "البحيرة",
    "بني سويف",
    "بورسعيد",
    "جنوب سيناء",
    "الجيزة",
    "الدقهلية",
    "دمياط",
    "سوهاج",
    "السويس",
    "الشرقية",
    "شمال سيناء",
    "الغربية",
    "الفيوم",
    "القاهرة",
    "القيلوبية",
    "قنا",
    "كفر الشيخ",
    "مطروح",
    "المنوفية",
    "المنيا",
    "الوادي الجديد"
]

export const WISDOM_PMS_CATEGORY_ICON = (categoryCode) => {
    const iconMap = {
        'Teacher': faUserTie,
        'Academic Principle': faGraduationCap,
        'Curriculum': faBookOpen,
        'HOD': faShieldAlt,
        'Edu Environment': faSchool,
        'Executive Manager': faBuilding,
        'Specialist': faIdCard,
        'Work Environment': faAddressCard,
        'Daily Operations': faClock,
        'PD': faChartLine,
        'behavior': faExclamationTriangle,
        'gradebook': faBookOpen,
    };
    return iconMap[categoryCode] || faClipboard;
};

export const WISDOM_PMS_CATEGORY_GRADIANT = (code) => {
    const map = {
        "Teacher": "from-blue-400 to-blue-600",
        "Academic Principle": "from-purple-400 to-purple-600",
        "Edu Environment": "from-yellow-300 to-yellow-500",
        "Executive Manager": "from-indigo-400 to-indigo-600",
        "HOD": "from-red-400 to-red-600",
        "Curriculum": "from-green-400 to-green-600",
        "Work Enivornment": "from-gray-400 to-gray-600",
        "PD": "from-pink-400 to-pink-600",
        "Daily Operations": "from-teal-400 to-teal-600",
        "behavior": "from-orange-400 to-orange-600",
        "gradebook": "from-slate-500 to-slate-700"
    };
    return map[code] || "from-slate-300 to-slate-500";
};

export const STUDENT_ATTENDANCE_STATUS_ARABIC = {
    attend: "حاضر",
    absent: "غائب",
    late: "متاخر",
    execused: "معفي"
}

export const CLASS_STATUS = [
    "ongoing",
    "finished",
    "onhold",
    "cancelled"
]

export const PARENT_STATUS_COLORS = {

    attend: '#10b981', // emerald-500

    absent: '#ef4444', // red-500

    late: '#f59e0b', // amber-500

    'left with parent': '#3b82f6', // blue-500

};

export const PARENT_TABS = [

    { id: 'overview', label: 'التقييم العام', icon: '🏠' },

    { id: 'attendance', label: 'سجل الحضور', icon: '📅' },

    { id: 'grades', label: 'سجل الدرجات', icon: '📊' },

    { id: 'evaluations', label: 'تقييمات المعلم', icon: '⭐' },

    { id: 'behaviors', label: 'سجل السلوكيات', icon: '📋' },

    { id: 'notes', label: 'ملاحظات الطلاب', icon: '📝', color: 'emerald' },

    { id: 'news', label: 'أخبار المدرسة', icon: '📰' },

    { id: 'points', label: 'النقاط والمكافآت', icon: '🏆' },

    { id: 'teachers', label: 'طاقم التدريس', icon: '👨‍🏫' },

];

export const PARENT_STATUS_AR = {

    attend: 'حاضر',

    absent: 'غائب',

    late: 'متأخر',

    'left with parent': 'انصرف مع ولي الأمر',

};

export const getWisdomAdminPanel = (language) => [
    {
        id: 'employees',
        title: 'Manage Employees',
        subtitle: language ? 'Manage Employees data' : 'ادارة بيانات الموظفين',
        description: language ? 'Manage Employees data' : 'ادارة بيانات الموظفين',
        icon: faUserTie,
        path: '/wisdom/admin/employees',
        color: 'from-blue-500 to-blue-600',
        available: true,
        notificationStatus: false
    },
    // {
    //     id: 'students',
    //     title: 'Manage Students',
    //     subtitle: language ? 'Manage Students data' : 'ادارة بيانات الطلاب',
    //     description: language ? 'Manage Students data' : 'ادارة بيانات الطلاب',
    //     icon: faUserGraduate,
    //     path: '/wisdom/admin/students',
    //     color: 'from-green-500 to-green-600',
    //     available: true,
    //     notificationStatus: false
    // },
    {
        id: 'organization',
        title: 'Manage Organization',
        subtitle: language ? 'Manage Organization data' : 'ادارة بيانات المركز',
        description: language ? 'Manage Organization data' : 'ادارة بيانات المركز',
        icon: faBuilding,
        path: '/wisdom/admin/organization',
        color: 'from-yellow-500 to-yellow-600',
        available: true,
        notificationStatus: false
    }
];

export const getWisdomAdminEmployeePanel = (language) => [
    {
        id: 'teacher assign class',
        title: 'Assign Teacher Class',
        subtitle: language ? 'Assign A Teacher to his classes' : 'تعيين المعلم للفصول الخاصة به',
        description: language ? 'Assign A Teacher to his classes' : 'تعيين المعلم للفصول الخاصة به',
        icon: faChalkboardTeacher,
        path: '/wisdom/admin/employees/teacher-class-assign',
        color: 'from-blue-500 to-blue-600',
        available: true,
        notificationStatus: false
    },
    {
        id: 'teacher manage subject',
        title: 'Manage Teacher Subject',
        subtitle: language ? 'Change The Teacher Subject' : 'تغيير مادة المعلم',
        description: language ? 'Change The Teacher Subject' : 'تغيير مادة المعلم',
        icon: faChalkboardTeacher,
        path: '/wisdom/admin/employees/teacher-subject-manage',
        color: 'from-red-500 to-red-600',
        available: true,
        notificationStatus: false
    },
    {
        id: 'employee personal data',
        title: 'Add Employee Personal Data',
        subtitle: language ? 'Add Employee Personal Data' : 'اضافة بيانات الموظفين',
        description: language ? 'Add Employee Personal Data' : 'اضافة بيانات الموظفين',
        icon: faUserTie,
        path: '/wisdom/admin/employees/personal-data',
        color: 'from-green-500 to-green-600',
        available: true,
        notificationStatus: false
    }
];

export const getWisdomAdminOrganizationPanel = (language) => [
    {
        id: 'manage workshop tools',
        title: 'Manage Workshop Tools',
        subtitle: language ? 'Manage Workshop Tools Status' : 'ادارة حالة ادوات الورش',
        description: language ? 'Manage Workshop Tools Status' : 'ادارة حالة ادوات الورش',
        icon: faGear,
        path: '/wisdom/admin/organization/workshop-tools',
        color: 'from-blue-500 to-blue-600',
        available: true,
        notificationStatus: false
    }
];

export const TAILWIND_COLORS = [
    "bg-red-500",
    "bg-blue-500",
    "bg-green-500",
    "bg-yellow-500",
    "bg-purple-500",
    "bg-pink-500",
    "bg-indigo-500",
    "bg-cyan-500",
    "bg-orange-500",
    "bg-emerald-500",
];

export const CURRENT_YEAR = new Date().getFullYear();

export const STAGES_AR = {
    "First Secondary": "الصف الاول",
    "Second Secondary": "الصف الثاني",
    "Third Secondary": "الصف الثالث"
}